// removed by extract-text-webpack-plugin
module.exports = {"Main":"confirmation__Main__2PG3m"};


//////////////////
// WEBPACK FOOTER
// ./src/Layout/Confirmation/confirmation.css
// module id = 1230
// module chunks = 2